module.exports = __webpack_public_path__ + "img/ajax.75d6a127.png";